import React from "react";
import About from "../about";
import Brochure from "../brochure";
import Featuring from "../featuring";
import Glimpse from "../glimpse";
import Hero from "../hero";
import KeyDates from "../keyDates";
import Scope from "../scope";
import Modal from "react-modal";
import { AiOutlineCloseCircle } from 'react-icons/ai';
import pdfUrl from './Final Schedule VETOMAC 2023.pdf';
import pdfLoP from './List of registered participants.pdf';
import Template from "../template";
import Summary from "../summary";

const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
};

function Home() {

    const [modalIsOpen, setIsOpen] = React.useState(true);
    function closeModal() {
        setIsOpen(false);
    }

    const downloadProgramSummary = () => {
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = "VETOMAC 2023 Program Summary.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    const downloadLoP = () => {
        const link = document.createElement("a");
        link.href = pdfLoP;
        link.download = "VETOMAC 2023 List of registered participants.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    return (
        <>
            <Hero />
            <Featuring />
            <About />
            <KeyDates />
            <Summary />
            <Template />
            <Scope />
            <Glimpse />
            <Brochure />
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={customStyles}
            >
                <div className="conf" style={{cursor: 'pointer', fontSize: '3vmax', position: 'absolute', right: '1vmax', top: 0}} onClick={closeModal}><AiOutlineCloseCircle /></div>
                {/* <h2><u className="conf" style={{fontWeight: 600, color: 'red'}}>Important:</u></h2>
                <div className="conf">Deadline to submit request for accomodation is <span style={{color: 'red', fontSize: '1.6vmax', fontWeight: 600}}>14th Dec, 2023, 11:59PM</span></div> */}
                <h2><u className="conf" style={{fontWeight: 600}}>Note:</u></h2>
                <div className="conf">Fill preference for <span style={{color: 'blue', fontSize: '1.6vmax', fontWeight: 600}}>accomodation request</span> <a style={{all: 'unset', color: 'red', fontSize: '1.6vmax', fontWeight: 600, cursor: 'pointer'}} href="https://docs.google.com/spreadsheets/d/1fQgLqXppNpjNATbMjSdC4CqcwzCOQOt_uIsy5ffgieI/edit?usp=sharing" target="_blank">here</a></div>
                <div className="conf"><span style={{color: 'blue', fontSize: '1.6vmax', fontWeight: 600}}>Final</span> program schedule (updated 15th Dec, 2023) is available <span onClick={downloadProgramSummary} style={{color: 'red', fontSize: '1.6vmax', fontWeight: 600, cursor: 'pointer'}}>here</span></div>
                {/* <div className="conf">List of registered participants is available <span onClick={downloadLoP} style={{color: 'red', fontSize: '1.6vmax', fontWeight: 600, cursor: 'pointer'}}>here</span></div> */}
            </Modal>
        </>
    )
}

export default Home;